import * as React from 'react';
import { SVGProps } from 'react';

const IconWellsSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.923 1.808 4.808 11.538a.5.5 0 0 1-.923.385l-.097-.231h-8.5l-.096.23a.5.5 0 1 1-.923-.384L9 1.808h.923ZM5.628 12.5h7.667l-.834-2h-6l-.833 2Zm1.25-3h5.167l-.834-2h-3.5l-.833 2Zm1.25-3h2.667L9.462 3.3 8.128 6.5Z"
      fill="var(--color-typo-system)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.462 1a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Z"
      fill="var(--color-typo-normal)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 8.5a.5.5 0 0 0 .316-.632L3.595 1.203a.1.1 0 0 0-.19 0L1.184 7.868a.5.5 0 0 0 .948.316L2.36 7.5h2.28l.228.684A.5.5 0 0 0 5.5 8.5Zm-1.194-2L3.5 4.081 2.694 6.5h1.612Z"
      fill="var(--color-typo-system)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Z"
      fill="var(--color-typo-normal)"
    />
  </svg>
);
export default IconWellsSizeS;
